<script lang="ts">
    import { Navigation } from '../../utilities/Navigation';
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import FilterMaps from '../Filter/FilterMaps.svelte';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import IconAdd from '../../shared/Icons/IconAdd.svelte';
    import MapList from './MapList.svelte';
    import { currentMainFilter } from '../../../stores/filter';
    import { MapApi } from './MapApi';
    // import {currentMap} from "../../stores/api";
    import { api } from '../../../stores/api';
    import { onMount } from 'svelte';
    import Separator from '../../shared/Separator.svelte';

    let error = '';

    function createNewMap() {
        MapApi.create(get(api), { name: 'New Map', schedule: { when: 'always' } })
            .then(map => {
                // $currentMap = map.id;
                error = '';
                Navigation.navigate('/map/' + map.id);
            })
            .catch(err => {
                console.log(err);
                error = err;
            });
    }

    onMount(() => {
        $currentMainFilter = FilterMaps;
        return () => {
            $currentMainFilter = null;
        };
    });
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="main-header">
        {$_('Maps')}
    </div>
    <div slot="main-buttons">
        <IconAdd hover="Create new map" on:click={createNewMap} />
    </div>
    <div slot="content-header"></div>
    <div slot="content">
        <Separator />
        {#if error}
            <MessageDanger header={$_('Cannot load zones')} {error} />
        {/if}
        <FilterMaps />
        <Separator />
        <MapList />
    </div>
</TemplateStandard>

<style>
</style>
